import { Inbox } from '@core/models/interfaces/storage-data/inbox';
import { createActionGroup, props } from '@ngrx/store';

export const InboxActions = createActionGroup({
  source: 'Inbox',
  events: {
    'Load Inbox Success': props<{ inbox: Inbox }>(),
  },
});
